export default {
    "[微笑]": "https://www.staic.lsstop.com/emoji/smile.gif",

    "[撇嘴]": "https://www.staic.lsstop.com/emoji/pz.gif",

    "[色]": "https://www.staic.lsstop.com/emoji/color.gif",

    "[发呆]": "https://www.staic.lsstop.com/emoji/daze.gif",

    "[得意]": "https://www.staic.lsstop.com/emoji/proud.gif",

    "[害羞]": "https://www.staic.lsstop.com/emoji/shy.gif",

    "[闭嘴]": "https://www.staic.lsstop.com/emoji/bz.gif",

    "[睡]": "https://www.staic.lsstop.com/emoji/sleep.gif",

    "[大哭]": "https://www.staic.lsstop.com/emoji/cry.gif",

    "[尴尬]": "https://www.staic.lsstop.com/emoji/gg.gif",

    "[发怒]": "https://www.staic.lsstop.com/emoji/rage.gif",

    "[调皮]": "https://www.staic.lsstop.com/emoji/naughty.gif",

    "[呲牙]": "https://www.staic.lsstop.com/emoji/cy.gif",

    "[惊讶]": "https://www.staic.lsstop.com/emoji/jingya.gif",

    "[难过]": "https://www.staic.lsstop.com/emoji/sad.gif",

    "[酷]": "https://www.staic.lsstop.com/emoji/ku.gif",

    "[冷汗]": "https://www.staic.lsstop.com/emoji/lenhan.gif",

    "[抓狂]": "https://www.staic.lsstop.com/emoji/crazy.gif",

    "[吐]": "https://www.staic.lsstop.com/emoji/tu.gif",

    "[偷笑]": "https://www.staic.lsstop.com/emoji/touxiao.gif",

    "[可爱]": "https://www.staic.lsstop.com/emoji/keai.gif",

    "[白眼]": "https://www.staic.lsstop.com/emoji/baiyan.gif",

    "[傲慢]": "https://www.staic.lsstop.com/emoji/aoman.gif",

    "[饥饿]": "https://www.staic.lsstop.com/emoji/hunger.gif",

    "[困]": "https://www.staic.lsstop.com/emoji/kun.gif",

    "[惊恐]": "https://www.staic.lsstop.com/emoji/jingko.gif",

    "[流汗]": "https://www.staic.lsstop.com/emoji/liuhan.gif",

    "[憨笑]": "https://www.staic.lsstop.com/emoji/hanxiao.gif",

    "[悠闲]": "https://www.staic.lsstop.com/emoji/youxian.gif",

    "[奋斗]": "https://www.staic.lsstop.com/emoji/fendou.gif",

    "[咒骂]": "https://www.staic.lsstop.com/emoji/zhouma.gif",

    "[疑问]": "https://www.staic.lsstop.com/emoji/yiwen.gif",

    "[嘘]": "https://www.staic.lsstop.com/emoji/xu.gif",

    "[晕]": "https://www.staic.lsstop.com/emoji/yun.gif",

    "[折磨]": "https://www.staic.lsstop.com/emoji/zhemo.gif",

    "[衰]": "https://www.staic.lsstop.com/emoji/shuai.gif",

    "[骷髅]": "https://www.staic.lsstop.com/emoji/kulou.gif",

    "[敲打]": "https://www.staic.lsstop.com/emoji/qiaoda.gif",

    "[再见]": "https://www.staic.lsstop.com/emoji/zaijian.gif",

    "[擦汗]": "https://www.staic.lsstop.com/emoji/cahan.gif",

    "[抠鼻]": "https://www.staic.lsstop.com/emoji/koubi.gif",

    "[鼓掌]": "https://www.staic.lsstop.com/emoji/guzhang.gif",

    "[糗大了]": "https://www.staic.lsstop.com/emoji/qiudale.gif",

    "[坏笑]": "https://www.staic.lsstop.com/emoji/huaixiao.gif",

    "[左哼哼]": "https://www.staic.lsstop.com/emoji/zhh.gif",

    "[右哼哼]": "https://www.staic.lsstop.com/emoji/yhh.gif",

    "[哈欠]": "https://www.staic.lsstop.com/emoji/haqian.gif",

    "[鄙视]": "https://www.staic.lsstop.com/emoji/bishi.gif",

    "[委屈]": "https://www.staic.lsstop.com/emoji/weiqu.gif",

    "[快哭了]": "https://www.staic.lsstop.com/emoji/kuaikule.gif",

    "[阴险]": "https://www.staic.lsstop.com/emoji/yinxian.gif",

    "[亲亲]": "https://www.staic.lsstop.com/emoji/qinqin.gif",

    "[吓]": "https://www.staic.lsstop.com/emoji/xia.gif",

    "[可怜]": "https://www.staic.lsstop.com/emoji/kelian.gif",

    "[眨眼睛]": "https://www.staic.lsstop.com/emoji/zhayanjing.gif",

    "[笑哭]": "https://www.staic.lsstop.com/emoji/xiaoku.gif",

    "[doge]": "https://www.staic.lsstop.com/emoji/doge.gif",

    "[泪奔]": "https://www.staic.lsstop.com/emoji/leiben.gif",

    "[无奈]": "https://www.staic.lsstop.com/emoji/wunai.gif",

    "[托腮]": "https://www.staic.lsstop.com/emoji/tuosai.gif",

    "[卖萌]": "https://www.staic.lsstop.com/emoji/maimeng.gif",

    "[斜眼笑]": "https://www.staic.lsstop.com/emoji/xyx.gif",

    "[喷血]": "https://www.staic.lsstop.com/emoji/px.gif",

    "[惊喜]": "https://www.staic.lsstop.com/emoji/jx.gif",

    "[骚扰]": "https://www.staic.lsstop.com/emoji/sr.gif",

    "[小纠结]": "https://www.staic.lsstop.com/emoji/xjj.gif",

    "[我最美]": "https://www.staic.lsstop.com/emoji/wzm.gif",

    "[加油抱抱]": "https://www.staic.lsstop.com/emoji/jybb.gif",

    "[脑阔疼]": "https://www.staic.lsstop.com/emoji/nkt.gif",

    "[沧桑]": "https://www.staic.lsstop.com/emoji/cs.gif",

    "[捂脸]": "https://www.staic.lsstop.com/emoji/wl.gif",

    "[辣眼睛]": "https://www.staic.lsstop.com/emoji/lyj.gif",

    "[哦哟]": "https://www.staic.lsstop.com/emoji/oy.gif",

    "[头秃]": "https://www.staic.lsstop.com/emoji/tt.gif",

    "[问号脸]": "https://www.staic.lsstop.com/emoji/whl.gif",

    "[暗中观察]": "https://www.staic.lsstop.com/emoji/azgc.gif",

    "[emm]": "https://www.staic.lsstop.com/emoji/emm.gif",

    "[吃瓜]": "https://www.staic.lsstop.com/emoji/cg.gif",

    "[呵呵哒]": "https://www.staic.lsstop.com/emoji/hhd.gif",

    "[无眼笑]": "https://www.staic.lsstop.com/emoji/wyx.gif",

    "[狂笑]": "https://www.staic.lsstop.com/emoji/kx.gif",

    "[面无表情]": "https://www.staic.lsstop.com/emoji/mwbq.gif",

    "[加油]": "https://www.staic.lsstop.com/emoji/jiayou.gif",

    "[魔鬼笑]": "https://www.staic.lsstop.com/emoji/mgx.gif",

    "[拥抱]": "https://www.staic.lsstop.com/emoji/yb.gif",

    "[爱心]": "https://www.staic.lsstop.com/emoji/ax.gif",

    "[玫瑰]": "https://www.staic.lsstop.com/emoji/mg.gif",

    "[凋谢]": "https://www.staic.lsstop.com/emoji/dx.gif",

    "[幽灵]": "https://www.staic.lsstop.com/emoji/yl.gif",

    "[爆筋]": "https://www.staic.lsstop.com/emoji/bj.gif",

    "[示爱]": "https://www.staic.lsstop.com/emoji/shiai.gif",

    "[心碎]": "https://www.staic.lsstop.com/emoji/xs.gif",

    "[咖啡]": "https://www.staic.lsstop.com/emoji/kf.gif",

    "[羊驼]": "https://www.staic.lsstop.com/emoji/yt.gif",

    "[赞]": "https://www.staic.lsstop.com/emoji/z.gif",

    "[握手]": "https://www.staic.lsstop.com/emoji/ws.gif",

    "[胜利]": "https://www.staic.lsstop.com/emoji/sl.gif",

    "[踩]": "https://www.staic.lsstop.com/emoji/c.gif",

    "[点赞]": "https://www.staic.lsstop.com/emoji/dz.gif",

    "[托脸]": "https://www.staic.lsstop.com/emoji/tl.gif",

    "[拜托]": "https://www.staic.lsstop.com/emoji/bt.gif",

    "[无聊]": "https://www.staic.lsstop.com/emoji/wuliao.gif",

    "[我不看]": "https://www.staic.lsstop.com/emoji/wbk.gif",

    "[飙泪]": "https://www.staic.lsstop.com/emoji/bl.gif",

    "[害怕]": "https://www.staic.lsstop.com/emoji/hp.gif",

    "[我酸了]": "https://www.staic.lsstop.com/emoji/wsl.gif",

    "[月亮]": "https://www.staic.lsstop.com/emoji/yueliang.gif",

    "[太阳]": "https://www.staic.lsstop.com/emoji/ty.gif",

    "[猪头]": "https://www.staic.lsstop.com/emoji/zt.gif",

    "[菜刀]": "https://www.staic.lsstop.com/emoji/cd.gif",

    "[刀]": "https://www.staic.lsstop.com/emoji/d.gif",

    "[啤酒]": "https://www.staic.lsstop.com/emoji/pj.gif",

    "[茶]": "https://www.staic.lsstop.com/emoji/cha.gif",

    "[大便]": "https://www.staic.lsstop.com/emoji/db.gif",

    "[喝彩]": "https://www.staic.lsstop.com/emoji/hc.gif",

    "[足球]": "https://www.staic.lsstop.com/emoji/zq.gif",

    "[篮球]": "https://www.staic.lsstop.com/emoji/lq.gif",

    "[棒棒糖]": "https://www.staic.lsstop.com/emoji/bbt.gif",

    "[西瓜]": "https://www.staic.lsstop.com/emoji/xg.gif",

}